// Small shared atoms used across admin tab files.

export const STATUSES = [
    { key: "all", label: "All" },
    { key: "received", label: "Received" },
    { key: "shortlisted", label: "Shortlisted" },
    { key: "interview_scheduled", label: "Interview" },
    { key: "selected", label: "Selected" },
    { key: "rejected", label: "Rejected" },
    { key: "closed", label: "Closed" },
];

export function StatusPill({ status }) {
    const map = {
        received: "bg-white/10 text-ink",
        shortlisted: "bg-[#5fe3c9]/20 text-[#5fe3c9] border-[#5fe3c9]/40",
        interview_scheduled:
            "bg-[#07E6F6]/20 text-[#07E6F6] border-[#07E6F6]/40",
        selected: "bg-gradient-cyan text-[#0a0a0a]",
        rejected: "bg-red-500/20 text-red-300 border-red-500/40",
        closed: "bg-white/[0.04] text-ink-soft",
    };
    const cls = map[status] || map.received;
    return (
        <span
            data-testid={`status-pill-${status}`}
            className={`inline-flex items-center px-3 py-1.5 rounded-full text-[0.7rem] font-display font-bold uppercase tracking-[0.15em] border border-transparent ${cls}`}
        >
            {(status || "received").replace(/_/g, " ")}
        </span>
    );
}

export function Field({ label, children, testId }) {
    return (
        <label className="block" data-testid={testId}>
            <span className="block text-[10px] tracking-[0.25em] uppercase text-ink-soft mb-1.5">
                {label}
            </span>
            {children}
        </label>
    );
}

export function StatCell({ label, value, accent, testId }) {
    return (
        <div
            data-testid={testId}
            className={`p-5 ${accent ? "bg-gradient-cyan-dark" : "bg-background"}`}
        >
            <div className="vc-section-label text-ink-soft">{label}</div>
            <div
                className={`font-display font-black mt-1 ${accent ? "text-gradient" : "text-ink"}`}
                style={{ fontSize: "clamp(1.4rem, 2.2vw, 2rem)" }}
            >
                {value}
            </div>
        </div>
    );
}

export function Select({ value, onChange, options, testId }) {
    return (
        <div className="relative">
            <select
                data-testid={testId}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                className="w-full appearance-none bg-white/[0.04] border border-line focus:border-[#5fe3c9] rounded-full px-5 py-3 pr-10 outline-none font-body text-ink"
            >
                {options.map((o) => (
                    <option
                        key={o.value}
                        value={o.value}
                        className="bg-[#0a0a0a]"
                    >
                        {o.label}
                    </option>
                ))}
            </select>
            <span className="absolute right-5 top-1/2 -translate-y-1/2 text-ink-soft pointer-events-none">
                ▾
            </span>
        </div>
    );
}

export function fmtDate(s) {
    if (!s) return "";
    try {
        const d = new Date(s);
        return d.toLocaleDateString(undefined, {
            year: "numeric",
            month: "short",
            day: "numeric",
        });
    } catch {
        return s;
    }
}

export function fmtTime(iso) {
    if (!iso) return "";
    try {
        const d = new Date(iso);
        return d.toLocaleString(undefined, {
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    } catch {
        return iso;
    }
}

export function prettyTpl(t) {
    if (!t) return "";
    return t.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export function PageHeader({ eyebrow, title, accent, description, actions }) {
    return (
        <div className="grid md:grid-cols-12 gap-y-4 md:gap-x-10 items-end mb-8 md:mb-10">
            <div className="md:col-span-8">
                {eyebrow && (
                    <div className="vc-section-label text-[#5fe3c9] mb-3">
                        {eyebrow}
                    </div>
                )}
                <h1
                    className="font-display font-black uppercase tracking-tightest leading-[0.95]"
                    style={{ fontSize: "clamp(1.7rem, 4.2vw, 3.4rem)" }}
                    data-testid="page-title"
                >
                    {title}{" "}
                    {accent && (
                        <span className="text-gradient">{accent}</span>
                    )}
                </h1>
            </div>
            <div className="md:col-span-4 flex flex-col md:items-end gap-3">
                {description && (
                    <p className="text-ink-soft leading-relaxed text-sm">
                        {description}
                    </p>
                )}
                {actions}
            </div>
        </div>
    );
}

export const EVENT_META = {
    "email.sent": { label: "Sent", color: "#90FDA6", dot: "#90FDA6" },
    "email.delivered": { label: "Delivered", color: "#90FDA6", dot: "#90FDA6" },
    "email.delivery_delayed": {
        label: "Delayed",
        color: "#F8FF28",
        dot: "#F8FF28",
    },
    "email.opened": { label: "Opened", color: "#07E6F6", dot: "#07E6F6" },
    "email.clicked": { label: "Clicked", color: "#07E6F6", dot: "#07E6F6" },
    "email.bounced": { label: "Bounced", color: "#ff6b6b", dot: "#ff6b6b" },
    "email.complained": { label: "Complaint", color: "#ff6b6b", dot: "#ff6b6b" },
};
